import Vue from 'vue';
import Vuex from 'vuex';

import db from '@/db';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    darkmode: false,
    currentTrackingId: -1,
    // Was ist der Name des aktuellen todos?
    currentTrackingTitle: 'Halleluja',
    // Wie viel Zeit in Millisekunden wurden für das Todo angegeben
    currentTrackingTime: 0,
    currenTrackingStartTime: 0,
    currentTrackingDoneTime: 0,
    endTracking: 0,
    hideFinishedTodos: false,
    roundingFactor: 1,
    toasties: [],
    trackingIntervall: null,
    onboardingComplete: false,
    installAsked: false,
    installPrompt: null,
  },
  mutations: {

    setOnboardingComplete(state, value) {
      state.onboardingComplete = value;
    },

    setInstallAsked(state, value) {
      state.installAsked = value;
    },

    addToasty(state, toasty) {
      // if there is no id yet create new id for toasty
      if (!toasty.id) toasty.id = Math.random().toString(36).substring(2, 9); // eslint-disable-line no-param-reassign
      // add new toasty to toast array
      state.toasties.push(toasty);
      // console.log(state.toasties);
    },

    closeToasty(state, id) {
      // find index of toasty by its id
      const i = state.toasties.findIndex((existingToast) => existingToast.id === id);
      // splice toastie
      state.toasties.splice(i, 1);
    },

    updateTrackingInformation(state, todo) {
      state.currentTrackingTitle = todo.title;
      state.currentTrackingTime = todo.time;
    },

    updateTrackingIntervall(state, timePassed) {
      state.currentTrackingTimePassed = timePassed;
    },

    updateEndTracking(state, value) {
      state.endTracking = value;
    },

    setdarkmode(state, value) {
      state.darkmode = value;
    },

    setTrackingId(state, value) {
      state.currentTrackingId = value;
    },

    setTrackingData(state, trackingData) {
      state.currentTrackingTitle = trackingData.trackingTitle;
      state.currentTrackingTime = trackingData.trackingTime;
      state.currentTrackingStartTime = trackingData.startTime;
      state.currentTrackingId = trackingData.trackingId;
    },

    // Initialisiere wie viel bereits getrackt wurde
    // Update, wenn es eine neue Zeit gibt
    setTrackingTime(state, donetime) {
      state.currentTrackingDoneTime = donetime;
      // Hier funktioniert es
    },

    reinitializeTracking(state) {
      state.currentTrackingTitle = '';
      state.currentTrackingTime = 0;
      state.currentTrackingStartTime = 0;
      state.currentTrackingDoneTime = 0;
    },

    toggleHideFinishedTodos(state, value) {
      state.hideFinishedTodos = value;
    },

    setInstallPrompt(state, prompt) {
      state.installPrompt = prompt;
    },
  },
  actions: {
    async startTracking({ commit, state, dispatch }, trackingData) {
      // TrackingData: trackingTitle, trackingID, trackingDoneTime, currenTrackingStartTime, trackingTime
      // Case Anschalten
      if (state.trackingId !== -1) {
        try {
          await dispatch('stopTracking');
        } catch (err) {
          console.warn(`Error trying to Stop Tracking ${err.message}`);
        }
      }
      // Store Tracking Data form Component to State
      commit('setTrackingData', trackingData);
      commit('setTrackingTime', trackingData.trackingDoneTime);
      commit('setdarkmode', true);

      // Beim starten der Datenbank festlegen, wann das Todo gestartet wird, wird später beim Beenden gebraucht
      try {
        await db.todos.update(trackingData.trackingId, { startTracking: trackingData.startTime });
      } catch (err) {
        console.warn(`Error adding StartTime to current Tracking Todo ${err.message}`);
      }
      // In die Einstellungen schreiben, welched Todo gerade getrackt wird
      const id = state.currentTrackingId;
      try {
        await db.config.put({ name: 'trackingId', value: id });
      } catch (err) {
        console.warn(`Error pushing current Id to Config: ${err.message}`);
      }

      state.trackingIntervall = setInterval(() => {
        const delta = (Date.now() - trackingData.startTime) + trackingData.trackingDoneTime;
        commit('setTrackingTime', delta);
        // console.log(delta);
      }, 1000);
    },

    async stopTracking({ commit, state }) {
      // Clear Intervall
      clearInterval(state.trackingIntervall);
      try {
        await db.todos.update(state.currentTrackingId, { donetime: state.currentTrackingDoneTime });
      } catch (err) {
        console.warn(`Error pushing the tracked Time to Todos Donetime: ${err.message}`);
      }
      // Dem Store in der Datenbank sagen, dass die ID wieder -1 ist
      commit('setTrackingId', -1);
      try {
        await db.config.put({ name: 'trackingId', value: -1 });
      } catch (err) {
        console.warn(`Error reinitializing config TrackingId Variable: ${err.message}`);
      }
      // Den darkmode wieder ausschalten
      state.darkmode = false;
      // commit('reinitializeTracking');
    },

    async toggleHideFinishedTodos({ commit }, value) {
      commit('toggleHideFinishedTodos', value);
      try {
        await db.config.put({ name: 'hideFinishedTodos', value });
      } catch (err) {
        console.warn(`Error pushing config hide show: ${err.message}`);
      }
    },

    async setOnboardingComplete() {
      try {
        await db.config.put({ name: 'onboardingComplete', value: true });
      } catch (err) {
        console.warn(`Error pushing config onboardingComplete: ${err.message}`);
      }
    },

    async setInstallAsked() {
      try {
        await db.config.put({ name: 'installAsked', value: true });
      } catch (err) {
        console.warn(`Error pushing config installAsked: ${err.message}`);
      }
    },

  },
  modules: {
  },
});
